import Queja from "../interfaces/Queja.interface";
import Fecha from "../tools/Fecha.tool";



const getEstructura = (): Queja => {
    const queja: Queja = {
        IdQueja: 0,
        quejasDenominacion: "Sinergia Financiera de México, S.A. de C.V., SOFOM, E.N.R.",
        quejasSector: "Sociedades Financieras de Objeto Múltiple E.N.R.",
        quejasNoMes: /*3*/ Fecha.getAnioMes(),
        quejasNum: 1,
        quejasFolio: "",
        quejasFecRecepcion: /*"10/03/2024"*/Fecha.getDateToDay(),
        quejasMedio: /*1*/0,
        quejasNivelAT: /*4*/0,
        quejasProducto: /*"126911811258"*/"NAN",
        quejasCausa: /*"08777"*/"0",
        quejasPORI: /*"SI"*/ "NAN",
        quejasEstatus: /*2*/0,
        quejasEstados: /*4*/0,
        quejasMunId: /*2*/0,
        quejasLocId: /*9*/null,
        quejasColId: /*32*/0,
        quejasCP: /*24026*/0,
        quejasTipoPersona: /*1*/0,
        quejasSexo: "NAN",
        quejasEdad: 0,
        quejasFecResolucion: /*"15/03/2024"*/Fecha.getDateToDay(),
        quejasFecNotificacion: /*"15/03/2024"*/Fecha.getDateToDay(),
        quejasRespuesta: /*1*/0,
        quejasNumPenal: /*1*/0,
        quejasPenalizacion: /*1*/0,
        quejasMedioDescripcion: "",
        quejasNivelATDecripcion: "",
        quejasProductoDescripcion: "",
        quejasCausaDescripcion: "",
        quejasEstadosDescripcion: "",
        quejasMunIdDescripcion: "",
        quejasColDescripcion: ""
    };

    return queja;

};

const validarDatosQueja = (data: Queja): boolean => {
    let value: boolean = true;
    const {
        quejasDenominacion,
        quejasSector,
        quejasNum,
        quejasFolio,
        quejasMedio,
        quejasNivelAT,
        quejasProducto,
        quejasCausa,
        quejasPORI,
        quejasEstatus,
        quejasEstados,
        quejasMunId,
        quejasColId,
        quejasTipoPersona,
        quejasSexo,
        quejasRespuesta,
        quejasNumPenal,
        quejasPenalizacion
    } = data;

    if (quejasDenominacion.length === 0) value = false;
    if (quejasSector.length === 0) value = false;
    if (quejasNum === 0) value = false;
    if (quejasFolio.length === 0) value = false;
    if (quejasMedio === 0) value = false;
    if (quejasNivelAT === 0) value = false;
    if (quejasProducto === "NAN") value = false;
    if (quejasCausa === "0") value = false;
    if (quejasPORI === "NAN") value = false;
    if (quejasEstatus === 0) value = false;
    if (quejasEstados === 0) value = false;
    if (quejasMunId === 0) value = false;
    if (quejasColId === 0) value = false;
    if (quejasTipoPersona === 0) value = false;
    if (quejasSexo === "NAN") value = false;
    if (quejasRespuesta === 0) value = false;
    if (quejasNumPenal === 0) value = false;
    if (quejasPenalizacion === 0) value = false;

    return value;
}

const QuejaModel = {
    getEstructura,
    validarDatosQueja,
}

export default QuejaModel;